export const TEREA = 'TEREA';
export const LEVIA = 'LEVIA';
